const NoPage = () => {
  return <h1>这个页面还没挖出来</h1>;
};

export default NoPage;
